import {
    SYSTEMCONFIG_CHOOSE_CURRENT_SYSTEMCONFIG,
} from './constants';
  
export function chooseCurrentSystemConfig(modal) {
    return {
      type: SYSTEMCONFIG_CHOOSE_CURRENT_SYSTEMCONFIG,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEMCONFIG_CHOOSE_CURRENT_SYSTEMCONFIG:
        return {
          ...state,
          currentSystemConfig:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/chooseCurrentSystemConfig.js